import React, { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { get, size } from 'lodash'
import { Button, Container, Grid, Typography } from '@material-ui/core'
import { useReactToPrint } from 'react-to-print'
import moment from 'moment'

import CustomTable from '../../components/table/CustomTable'
import ButtonBackHeader from '../../components/ButtonBackHeader/ButtonBackHeader'
import ticketStyles from './css/ticketStyles'
import { fetchData } from '../../api/api'
import { useSession } from '../../contexts/SessionContext'
import PrintTicket from '../../components/PrintTicket/PrintTicket'

const headCellsSku = [{ id: 'id', numeric: false, order: false, label: 'SKU' }]

const createSkuRows = ({ id = '-' }) => {
  return { id }
}

const Ticket = ({ location }) => {
  const classes = ticketStyles()
  const history = useHistory()
  const { sessionData } = useSession()

  const selectedRows = get(location, 'state.selectedRows') || []
  const ticketData = get(location, 'state.orderData') || {}

  const [tableRows] = useState(
    selectedRows.map(row => {
      return createSkuRows({ id: row })
    })
  )
  const [curretPage, setCurrentPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState('id')
  const [numberOfPages] = useState(1)
  const [isDataLoading] = useState(false)

  const printComponentRef = useRef()
  const handlePrintClick = useReactToPrint({
    content: () => printComponentRef.current,
  })

  const handlePOSPrintClick = () => {
    const formatDate = moment(get(ticketData, 'fecha') || '', 'YYYY-MM-DD').format('DD/MM/YYYY')
    const barcodeDate = moment(get(ticketData, 'fecha') || '', 'YYYY-MM-DD').format('DDMMYY')
    const barcodeString = `${barcodeDate}${get(ticketData, 'sucursal') || ''}${
      get(ticketData, 'caja') || ''
    }${get(ticketData, 'numeroTrx') || ''}`

    window.open(
      `myprinter://@${get(ticketData, 'sucursalCom') || ''}@${get(ticketData, 'sucursal') || ''}@${
        get(ticketData, 'caja') || ''
      }@${formatDate}@${get(ticketData, 'numeroTrx') || ''}@${
        get(ticketData, 'boleta') || ''
      }@${barcodeString}@${size(selectedRows)}@${selectedRows}`,
      '_blank'
    )

    try {
      return fetchData({
        view: 'ticket',
        userAuthKey: get(sessionData, 'userAuthKey'),
        barcodeString,
      })
    } catch (error) {
      return error
    }
  }

  const handleActionButtonClick = () => {
    return history.push('buscar')
  }

  return (
    <div className={classes.root}>
      <Container className={classes.container}>
        <ButtonBackHeader
          buttonText="Nueva búsqueda"
          onActionButtonClick={handleActionButtonClick}
          icon="search"
        />
        <Typography variant="h5">Nuevo ticket de regalo</Typography>
        <Typography variant="body1" color="textSecondary">
          Ticket generado el {get(ticketData, 'fecha') || '-'}
        </Typography>
        <div className={classes.gridContainer}>
          <Grid container spacing={4}>
            <Grid item xs>
              <Typography noWrap variant="body2" color="primary" className={classes.boldFont}>
                Sucursal
              </Typography>
              <Typography variant="body2">{get(ticketData, 'sucursal') || '-'}</Typography>
              <Typography noWrap variant="body2" color="primary" className={classes.boldFont}>
                Nro. de transacción
              </Typography>
              <Typography variant="body2">{get(ticketData, 'numeroTrx') || '-'}</Typography>
            </Grid>
            <Grid item xs>
              <Typography noWrap variant="body2" color="primary" className={classes.boldFont}>
                Caja
              </Typography>
              <Typography variant="body2">{get(ticketData, 'caja') || '-'}</Typography>
              <Typography noWrap variant="body2" color="primary" className={classes.boldFont}>
                Fec. Transacción
              </Typography>
              <Typography variant="body2">{get(ticketData, 'fecha') || '-'}</Typography>
            </Grid>
          </Grid>
        </div>

        <CustomTable
          className={classes.table}
          rows={tableRows}
          headCells={headCellsSku}
          page={curretPage}
          setPage={setCurrentPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          order={order}
          setOrder={setOrder}
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          isDataLoading={isDataLoading}
          numberOfPages={numberOfPages}
          hidePagination
        />

        <div className={classes.printTicketContainer}>
          <PrintTicket ref={printComponentRef} ticketData={ticketData} skuList={tableRows} />
        </div>

        <div className={classes.buttonsContainer}>
          <Button
            size="large"
            variant="outlined"
            color="primary"
            type="submit"
            fullWidth
            onClick={handlePOSPrintClick}
            className={classes.printButton}
          >
            USAR POS MOBILE
          </Button>
          <Button
            size="large"
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            onClick={handlePrintClick}
            className={classes.printButton}
          >
            Imprimir Ticket
          </Button>
        </div>
      </Container>
    </div>
  )
}

Ticket.propTypes = {}

export default Ticket
